// extracted by mini-css-extract-plugin
module.exports = {"heading":"AllNamesContainer_heading__1ihKB","button":"AllNamesContainer_button__3JBps"};